import React, { useCallback, useMemo } from 'react';
import CSSModules from 'react-css-modules';
import * as PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import get from 'lodash/get';
import { useDispatch, useSelector } from 'react-redux';

import { fullProviderSubtitle } from '../../../../utils/appointments/provider-details-formatter';
import { appointmentProgressActions } from '../../../../redux/appointmentForm/progress-types';
import * as providerGWDetails from '../../../../redux/appointmentForm/requests/provider-GW-details-req';
import Shape from '../../../common/Shape';
import {
  APPOINTMENT_FORM,
  APPOINTMENT_FORM_PROVIDER_DETAILS,
} from '../../../../constants/routes';
import ProviderNameAvatar from '../ProviderNameAvatar';
import TimeSlots from '../TimeSlots';
import {
  selectAppointmentDateFilter,
  selectProgressOrganizationId,
  selectSchedulePayloadData,
} from '../../../../redux/appointmentForm/selectors';
import { PROVIDER_CALENDAR_SOURCE } from '../../../../constants';
import styles from './styles.styl';

function ProviderCard({ provider, onTimeSelect, locationId }) {
  const dispatch = useDispatch();
  const renderProviderSubTitle = useCallback(fullProviderSubtitle, []);
  const payload = useSelector(selectSchedulePayloadData);
  const date = useSelector(selectAppointmentDateFilter);
  const organizationId = useSelector(selectProgressOrganizationId);
  const { id, timeSlots, timeSlotsSource } = provider || {};
  const isGWCreatedFlow =
    get(provider, 'timeSlotsSource', '') !== PROVIDER_CALENDAR_SOURCE;

  const providerPath = useMemo(() => {
    const formattedUrl = APPOINTMENT_FORM_PROVIDER_DETAILS.replace(':id', id);
    return `${APPOINTMENT_FORM}/${formattedUrl}#${locationId}`;
  }, [id, locationId]);

  const handleTimeSelectPerProvider = time => {
    if (isGWCreatedFlow) {
      const data = {
        ...payload,
        providerId: id,
        date,
        organizationId,
        timeSlotsSource,
      };
      dispatch(providerGWDetails.actions.send(data));
    }
    handleOnClick();
    onTimeSelect(time, provider);
  };

  const handleOnClick = () => {
    dispatch(appointmentProgressActions.setCreateTypeFlowGW(isGWCreatedFlow));
  };

  return (
    <Shape styleName="root">
      <div styleName="row">
        <ProviderNameAvatar
          withoutLocation
          avatarSize={40}
          provider={provider}
          renderMeta={renderProviderSubTitle}
        />
        <div styleName="right">
          <Link to={providerPath} onClick={handleOnClick} styleName="link">
            <FormattedMessage id="reports.seeDetails" />
          </Link>
        </div>
      </div>
      <div styleName="separator" />
      <div styleName="content">
        <TimeSlots list={timeSlots} onSelect={handleTimeSelectPerProvider} />
      </div>
    </Shape>
  );
}

ProviderCard.propTypes = {
  provider: PropTypes.object,
  onTimeSelect: PropTypes.func,
  locationId: PropTypes.number,
};

export default CSSModules(ProviderCard, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/Components/ProviderCard/index.jsx